module.exports = __webpack_public_path__ + "static/media/filter-dirty-light.1c90f876.svg";